import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mkt-status-badge',
  template: `
    <span class="mkt-status-badge" [ngClass]="'mkt-status-' + (status || 'draft').toLowerCase()">
      {{ status }}
    </span>
  `,
  styles: [`
    .mkt-status-badge {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    .mkt-status-draft {
      background: var(--mj-status-warning-bg);
      color: var(--mj-status-warning-text);
    }
    .mkt-status-ready {
      background: var(--mj-status-info-bg);
      color: var(--mj-status-info-text);
    }
    .mkt-status-published {
      background: var(--mj-status-success-bg);
      color: var(--mj-status-success-text);
    }
    .mkt-status-archived {
      background: var(--mj-bg-surface-hover);
      color: var(--mj-text-muted);
    }
  `]
})
export class StatusBadgeComponent {
  @Input() status: string = 'Draft';
}
